import VideoItem from './VideoItem';

export default VideoItem;
